import type { SiteStoreWithInit } from '~/stores/site'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const siteStore: SiteStoreWithInit = useSiteStore()
  if (!siteStore.initialization) {
    console.error('Site store initialization not defined')
    return
  }
  await siteStore.initialization.fetchKontentData
  const currentLanguage = siteStore.$state.language
  const siteConfig = siteStore.$state.siteConfig
  const redirectEnabled = siteConfig.elements.redirectEnabled

  if (!validateRedirectEnabled(redirectEnabled?.value)) return

  const isRedirectEnabled =
    siteStore.$state.siteConfig.elements.redirectEnabled.value[0]?.codename === 'yes'
  if (!isRedirectEnabled) return

  const comingSoonPageCodename: string = siteConfig.elements.comingSoonPage?.value[0]
  const comingSoonPage = siteStore.$state.linkedItems[comingSoonPageCodename]
  const comingSoonPagePath = comingSoonPage?.elements.urlSlug?.value
  if (!comingSoonPagePath) return

  const { $sanitizeText } = useNuxtApp()
  const sanitizedPath = $sanitizeText(to.path)

  const sanitizedQuery = Object.fromEntries(
    Object.entries(to.query).map(([key, value]) => [
      $sanitizeText(key),
      typeof value === 'string' ? $sanitizeText(value) : value
    ])
  )
  const sanitizedHash = $sanitizeText(to.hash)

  const isEnglish = currentLanguage === siteStore.defaultLanguage
  const validComingSoonPaths = isEnglish
    ? [`/${comingSoonPagePath}`, `/${siteStore.defaultLanguage}/${comingSoonPagePath}`]
    : [`/${currentLanguage}/${comingSoonPagePath}`]

  if (validComingSoonPaths.includes(sanitizedPath)) return
  
  if (!currentLanguage) {
    console.error('Current language not set in site store')
  }

  const targetPath =
    isEnglish || !currentLanguage
      ? sanitizedPath.startsWith(`/${siteStore.defaultLanguage}/`)
        ? `/${siteStore.defaultLanguage}/${comingSoonPagePath}`
        : `/${comingSoonPagePath}`
      : `/${currentLanguage}/${comingSoonPagePath}`

  return navigateTo({ path: targetPath, query: sanitizedQuery, hash: sanitizedHash })
})

function validateRedirectEnabled(
  redirectEnabled: { name: string; codename: string }[] | undefined
) {
  if (!redirectEnabled || !Array.isArray(redirectEnabled) || redirectEnabled.length === 0) {
    console.warn('redirectEnabled value not available in 🌍 Configuration File')
    return false
  }
  if (redirectEnabled.length > 1) {
    console.error('multiple values specified for redirectEnabled of 🌍 Configuration File')
    return false
  }
  return true
}
